import { LOGIN_LOGO_POOL } from "@redotech/redo-web/login/logos";
import { memo, useEffect, useRef, useState } from "react";
import * as css from "./animated-logos.module.css";

// Mirrors merchant/login/app/src/animated-logos — same logos and timing —
// so the intake modal's hero panel matches the login page.
const DISPLAY_COUNT = 4;
const SWAP_INTERVAL_MS = 2500;
const FADE_DURATION_MS = 700;

export const AnimatedLogos = memo(function AnimatedLogos() {
  const [displayed, setDisplayed] = useState(() =>
    LOGIN_LOGO_POOL.slice(0, DISPLAY_COUNT).map((l) => l.src),
  );
  const [fadingIndex, setFadingIndex] = useState<number | null>(null);
  const poolRef = useRef(LOGIN_LOGO_POOL);

  useEffect(() => {
    const timeouts = new Set<ReturnType<typeof setTimeout>>();

    const interval = setInterval(() => {
      const slot = Math.floor(Math.random() * DISPLAY_COUNT);
      setFadingIndex(slot);

      const timeout = setTimeout(() => {
        timeouts.delete(timeout);
        setDisplayed((prev) => {
          const next = [...prev];
          const hidden = poolRef.current.filter((l) => !next.includes(l.src));
          if (!hidden.length) {
            return prev;
          }
          const replacement = hidden[Math.floor(Math.random() * hidden.length)];
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          next[slot] = replacement!.src;
          return next;
        });
        setFadingIndex(null);
      }, FADE_DURATION_MS);
      timeouts.add(timeout);
    }, SWAP_INTERVAL_MS);

    return () => {
      clearInterval(interval);
      for (const t of timeouts) {
        clearTimeout(t);
      }
    };
  }, []);

  return (
    <div className={css.strip}>
      {displayed.map((src, i) => {
        const logo = LOGIN_LOGO_POOL.find((l) => l.src === src);
        return (
          <div className={css.logoWrapper} key={i}>
            <img
              alt={logo?.name ?? "merchant logo"}
              className={css.logo}
              src={src}
              style={{ opacity: fadingIndex === i ? 0 : 0.85 }}
            />
          </div>
        );
      })}
    </div>
  );
});
